window.Branch = window.Branch || {};
window.Branch.functions = window.Branch.functions || {};

window.Branch.functions.getStyle = function(el, styleProp) {
    var value, defaultView = (el.ownerDocument || document).defaultView;
    if (defaultView && defaultView.getComputedStyle) {
        styleProp = styleProp.replace(/([A-Z])/g, "-$1").toLowerCase();
        return defaultView.getComputedStyle(el, null).getPropertyValue(styleProp);
    } else if (el.currentStyle) { // IE
        styleProp = styleProp.replace(/\-(\w)/g, function(str, letter) {
            return letter.toUpperCase();
        });
        value = el.currentStyle[styleProp];
        if (/^\d+(em|pt|%|ex)?$/i.test(value)) {
            return (function(value) {
                var oldLeft = el.style.left,
                    oldRsLeft = el.runtimeStyle.left;
                el.runtimeStyle.left = el.currentStyle.left;
                el.style.left = value || 0;
                value = el.style.pixelLeft + "px";
                el.style.left = oldLeft;
                el.runtimeStyle.left = oldRsLeft;
                return value;
            })(value);
        }
        return value;
    }
}

/* Function that returns a srcset when passed an image URL */
window.Branch.functions.returnSrcSet = function(productImageUrl) {
  let returnedSrcSet;
  if(productImageUrl.includes('?v=')){
    returnedSrcSet = `${productImageUrl}&width=180 180w, ${productImageUrl}&width=360 360w, ${productImageUrl}&width=540 540w, ${productImageUrl}&width=720 720w, ${productImageUrl}&width=900 900w, ${productImageUrl}&width=1080 1080w, ${productImageUrl}&width=1280 1280w, ${productImageUrl}&width=1440 1440w`;
  } else {
    returnedSrcSet = `${productImageUrl}?width=180 180w, ${productImageUrl}?width=360 360w, ${productImageUrl}?width=540 540w, ${productImageUrl}?width=720 720w, ${productImageUrl}?width=900 900w, ${productImageUrl}?width=1080 1080w, ${productImageUrl}?width=1280 1280w, ${productImageUrl}?width=1440 1440w`;
  }
  return returnedSrcSet;
}

/* Function that returns a string it's passed with the first letter of each word capitalized */
window.Branch.functions.capitalizeWords = function(str) {
  return str.split(' ').map(word => {
      if (word === word.toUpperCase()) {
          return word.charAt(0) + word.slice(1).toLowerCase();
      }
      return word;
  }).join(' ');
}

window.Branch.functions.isTouchDevice = function() {
    return (('ontouchstart' in window) ||
       (navigator.maxTouchPoints > 0) ||
       (navigator.msMaxTouchPoints > 0));
  }

window.Branch.functions.onImagesLoaded = function(images, callback){
    var imagesLoaded = 0;
    var loadFunction = function() {
      imagesLoaded++;
      if(imagesLoaded==images.length) {
        callback();
      }
    };
    images.each(function(){
      var img = new Image();
      img.onload = loadFunction;
      img.onerror = loadFunction;
      if($(this).attr('src')){
        img.src = $(this).attr('src');
      }
      if($(this).attr('srcset')){
        img.srcset = $(this).attr('srcset');
      }
    });
  };

  window.Branch.functions.detectWrap = function(items) {
    var wrappedItems = [];
    var prevItem = {};
    var currItem = {};
    
    for (var i = 0; i < items.length; i++) {
      currItem = items[i].getBoundingClientRect();
      if (prevItem && prevItem.top < currItem.top) {
        wrappedItems.push(items[i]);
      }
      prevItem = currItem;
    };

    var wrapped = wrappedItems.length > 0 ? true : false;

    return wrapped;
  }

  window.Branch.functions.fixBody = function(type) {
    console.log('fixBody')
    const scrollY = window.pageYOffset || document.documentElement.scrollTop;
    if(type == "fix"){
      document.body.style.position = 'fixed';
      document.body.style.width = '100%';
      document.body.style.top = `-${scrollY}px`;
      document.body.setAttribute('data-fixed', true)
    } else {
      document.body.removeAttribute('data-fixed')
      const scrollY = document.body.style.top;
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.removeProperty('width');
      // window.scrollTo({left: 0, top: parseInt(scrollY || '0') * -1, behavior: 'instant'});
    }
  }

  window.Branch.functions.returnWindowWidth = function(){
    var width = window.innerWidth
    || document.documentElement.clientWidth
    || document.body.clientWidth;
    return width
  }
  
  window.Branch.functions.returnWindowHeight = function(){
    var height = window.innerHeight
|| document.documentElement.clientHeight
|| document.body.clientHeight;
    return height
  }

  window.Branch.functions.numberWithCommas = function(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

window.Branch.functions.stripVariantText = function(string, variantTextReplacementMetafield){
  let strippedString = string.replaceAll(' vegan leather', '').replaceAll(' Vegan Leather', '');
  if(variantTextReplacementMetafield){
    let downcaseString = strippedString.toLowerCase();
    variantTextReplacementMetafield.forEach((word) => {
      downcaseString = downcaseString.replaceAll(word, '')
    });
    strippedString = downcaseString.trim().replace(/\b\w/g, char => char.toUpperCase());
  }
  return strippedString;
}

window.Branch.functions.returnSingleSrc = function(type, url, width){
  let singleSrc = '';
  let urlTemp = url;

  if(type == 'srcset'){
    urlTemp = url.split(',')[0].trim().split(' ')[0];
  }

  if(urlTemp.includes('&width')){
    urlTemp = urlTemp.split('&width')[0]
  } else if (urlTemp.includes('?width')){
    urlTemp = urlTemp.split('?width')[0]
  }

  if(urlTemp.includes('?v=')){
    urlTemp = `${urlTemp}&width=${width}`
  } else {
    urlTemp = `${urlTemp}?width=${width}`
  }
  singleSrc = urlTemp;

  return singleSrc;
}

window.Branch.functions.debounce = function(func, wait) {
  let timeout;
  return function() {
    clearTimeout(timeout);
    timeout = setTimeout(() => func.apply(this, arguments), wait);
  };
}

window.Branch.functions.addEventListenerWithArg = function(element, event, handler, arg) {
  const listener = function(e) {
    handler(e, arg);
  };
  element.addEventListener(event, listener);

  return listener;
}

window.Branch.functions.returnCookieURL= function(cookieName){
  let cookieUrl = document.cookie
  .split("; ")
  .find((row) => row.startsWith(`${cookieName}=`))
  ?.split("=")[1]; 
  let url = "/"

  if(cookieUrl !== undefined && cookieUrl !== null && cookieUrl !== ''){
      url = cookieUrl;
  }

  return url
}

window.Branch.functions.getElementWithClass = function(event, className) {
  const target = event.target;

  if (target.classList.contains(className)) {
      return target;
  }

  let currentElement = target;
  while (currentElement.parentElement) {
      currentElement = currentElement.parentElement;
      if (currentElement.classList.contains(className)) {
          return currentElement;
      }
  }

  const matchingChild = target.querySelector(`.${className}`);
  if (matchingChild) {
      return matchingChild;
  }

  return null;
}

window.Branch.functions.isElementVisibleOrBelow = function(selector) {
  const element = document.querySelector(selector);
    if (!element) {
        return false; // Element doesn't exist
    }

    

    const rect = element.getBoundingClientRect();
    return (
        rect.bottom > 0 // Element is either within or below the viewport
    );
};

window.Branch.functions.isElementPartiallyOffScreen = function(selector) {
  const element = document.querySelector(selector);
  if (!element) {
      console.error(`Element with selector ${selector} not found`);
      return;
  }
  
  const rect = element.getBoundingClientRect();
  
  const isPartiallyOffScreen = (
      rect.top < 0 || 
      rect.left < 0 || 
      rect.bottom > window.innerHeight || 
      rect.right > window.innerWidth 
  );
  
  return isPartiallyOffScreen;
}

window.Branch.functions.updateHeightInCategory = function(allParentsSelector, allChildrenSelector){
  let parentElements = document.querySelectorAll(`${allParentsSelector}`);
  parentElements.forEach((parentElement) => {
      let childElements = parentElement.querySelectorAll(`${allChildrenSelector}`)
      let highestHeight = 0;
      childElements.forEach((childElement) => {
          childElement.style.removeProperty("height");
          if(childElement.offsetHeight > highestHeight){
              highestHeight = childElement.offsetHeight
          }
      });
      console.log('highestHeight', highestHeight)
      childElements.forEach((childElement) => {
          childElement.style.height = `${highestHeight}px`;
      })
  })
}

window.Branch.functions.defineInitFunctionSafely = function(functionName, func) {
  // Check if the function is already defined in the global scope
  if (typeof window[functionName] === "function") {
    console.warn(`Function "${functionName}" is already defined. New function not initialized.`);
    return;
  }

  // Flag to ensure the function only executes once
  let hasExecuted = false;

  // Define the new function
  window[functionName] = function (...args) {
      if (hasExecuted) {
          console.warn(`Function "${functionName}" has already been executed.`);
          return;
      }
      hasExecuted = true;
      func(...args);
  };
}

window.Branch.functions.capitalizeFirstLetter = function(val) {
  return String(val).charAt(0).toUpperCase() + String(val).slice(1);
}

window.Branch.functions.updateVariantParam = function(url, name, value) {
  const baseUrl = window.location.origin;
  if (!url.startsWith(baseUrl)) {
    url = baseUrl + url;
  }
  const urlObj = new URL(url); 
  urlObj.searchParams.set(name, value); 
  return urlObj.toString();
}

var discountCodeData = document.querySelector('#discount-code-data') ? JSON.parse(document.querySelector('#discount-code-data').innerText) : {};

window.Branch.functions.returnSalesTagText = function(salesTag, type){
  let salesTagText = '';

  if(type != 'fromHandle' && salesTag.getAttribute('data-sale-text') != undefined && salesTag.getAttribute('data-sale-text') != ""){
    salesTagText = salesTag.getAttribute('data-sale-text');
  } else if(discountCodeData){
    let productHandle = type == 'fromHandle' ? salesTag : salesTag.getAttribute('data-product-handle');
    if(discountCodeData.discount_code_1_product_handles.replaceAll(' ', '').split(",").includes(productHandle) && discountCodeData.discount_code_1_amount != undefined && discountCodeData.discount_code_1_amount > 0){
      salesTagText = `save ${discountCodeData.discount_code_1_amount}%`;
    } else if(discountCodeData.discount_code_2_product_handles.replaceAll(' ', '').split(",").includes(productHandle) && discountCodeData.discount_code_2_amount != undefined && discountCodeData.discount_code_2_amount > 0){
      salesTagText = `save ${discountCodeData.discount_code_2_amount}%`;
    } else if(discountCodeData.discount_code_auto_product_handles.replaceAll(' ', '').split(",").includes(productHandle) && discountCodeData.discount_code_auto_amount != undefined && discountCodeData.discount_code_auto_amount > 0){
      salesTagText = `save ${discountCodeData.discount_code_auto_amount}%`;
    }
  }
  return salesTagText;
}

window.Branch.functions.truncateText = function (text, maxWidth, font = "16px Quicksand") {
  const ctx = document.createElement("canvas").getContext("2d");
  ctx.font = font;
  if (ctx.measureText(text).width <= maxWidth) return text;

  while (text.length && ctx.measureText(text + "...").width > maxWidth) 
      text = text.slice(0, -1);

  return text + "...";
}
